import { Component, EventEmitter, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { StandardizedValidators } from 'src/app/helpers/StandardizedValidators';
import { ServerResponse } from 'src/app/models/ServerResponse';
import { ContactService } from 'src/app/services/contact.service';
import { ContactFormFields } from '../../classes/ContactFormFields';

@Component({
selector: 'app-contact-form',
templateUrl: './contact-form.component.html',
styleUrls: ['./contact-form.component.scss']
})
export class ContactFormComponent {

	fg : FormGroup;
	@Output() eeSent = new EventEmitter<boolean>();

	constructor(private contactService:ContactService) {
		this.fg = new FormGroup({
			"name": new FormControl(undefined, StandardizedValidators.fullName),
			"email": new FormControl(undefined, StandardizedValidators.email),
			"message": new FormControl(undefined, [Validators.required, Validators.maxLength(800)])
		});
	}

	//#region Form getters
	get fcName() { return this.fg.get("name")! }
	get fcEmail() { return this.fg.get("email")! }
	get fcMessage() { return this.fg.get("message")! }
	//#endregion

	submit() {
		this.fg.disable();
        let cff = new ContactFormFields(this.fcName.value, this.fcEmail.value, this.fcMessage.value);

		this.contactService.send(cff).subscribe({
			next: (sr:ServerResponse<boolean>)=> {
				this.eeSent.emit(sr.response);
			},
			error: (err:any)=> {
				this.fg.enable();
				this.eeSent.emit(false);
			}
		})
	}
}
